const NotFoundUtils = {
  asPathSlug: (asPath: string) => {
    const pathComponents = asPath.split(/[/~]/).filter(Boolean);
    return pathComponents[1];
  },
};

export default NotFoundUtils;
